import "./Loader.css";

function Loader({ size = "1.5rem" }) {
  return <div className="loader" style={{ fontSize: size }}></div>;
}

export default Loader;
